// Phase 9.2 — Purchase Order status meta (colours, labels).
// Kept separate from statusMeta.jsx (item-level statuses) to avoid
// naming collisions.

export const PO_STATUS_ORDER = ["draft", "released", "received", "cancelled"];

export const PO_STATUS_META = {
  draft: {
    label: "Draft",
    color: "bg-amber-50 text-amber-900 border-amber-300 dark:bg-amber-950/60 dark:text-amber-100 dark:border-amber-800",
  },
  released: {
    label: "Released",
    color: "bg-blue-50 text-blue-900 border-blue-300 dark:bg-blue-950/60 dark:text-blue-100 dark:border-blue-800",
  },
  received: {
    label: "Received",
    color: "bg-emerald-50 text-emerald-900 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-100 dark:border-emerald-800",
  },
  cancelled: {
    label: "Cancelled",
    color: "bg-neutral-100 text-neutral-500 border-neutral-300 line-through dark:bg-neutral-900/40 dark:text-neutral-500 dark:border-neutral-700",
  },
};

export function POStatusPill({ status, testid }) {
  const m = PO_STATUS_META[status] || { label: status, color: "" };
  return (
    <span
      data-testid={testid || `po-status-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium tracking-wide ${m.color}`}
    >
      {m.label}
    </span>
  );
}

export function PoFormatBadge({ format }) {
  const label = format === "pan_india" ? "Pan India" : "Location-wise";
  return (
    <span
      className="inline-flex items-center px-1.5 py-0.5 rounded border border-border/70 text-[10px] uppercase tracking-wider text-muted-foreground"
      data-testid={`po-format-${format}`}
    >
      {label}
    </span>
  );
}

export function fmtINR(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (!isFinite(n)) return "—";
  return n.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });
}
